import axios from "../axiosInstance"

export const respondToOffer = async ({ dealId, offerNumber, isAccepted }: { dealId: number, offerNumber: number, isAccepted: boolean }) => {
  try {
    const res = await axios.post("/offers/respond", { dealId, offerNumber, isAccepted })
    const { data } = res
    return data.success
  } catch (error) {
    console.error("Error responding to offer:", error)
    throw error
  }
}